import { createContext, useContext, useReducer } from "react"
import { geocodeByPlaceId } from "react-google-places-autocomplete"

export const initialFilters = {
    typeOfClass: null,
    online_type: null,
    location: "",
    coordinates: null,
}

const filterReducer = (state, action) => ({...state, ...action})

const FiltersContext = createContext({})

export const FiltersProvider = ({children}) => {
    const [filters, setFilters] = useReducer(filterReducer, initialFilters)

    const updateLocation = (newAddress, details) => {
        if (details?.[0]?.geometry?.location?.lat() && details?.[0]?.geometry?.location?.lng()) {
            const latitude = details?.[0]?.geometry?.location?.lat()
            const longitude = details?.[0]?.geometry?.location?.lng()

            setFilters({
                location: newAddress?.label || "",
                coordinates: {latitude, longitude},
            })
        }
    }

    const handleLocationChange = (e) => {
        if (!e) {
            setFilters({location: "", coordinates: null})
            return
        }

        geocodeByPlaceId(e.value.place_id)
            .then((results) => updateLocation(e, results))
            .catch(() =>
                setFilters({location: "", coordinates: null})
            )
    }

    return (
        <FiltersContext.Provider
            value={{filters, setFilters, handleLocationChange}}>
            {children}
        </FiltersContext.Provider>
    )
}

export const useFilters = () => {
    const context = useContext(FiltersContext)

    if (!context) {
        throw new Error("useFilters must be used within FiltersProvider")
    }
    return context
}
